import { IEnv } from '../components/Configurator';
import { IToken, TokenRequestError, TokenCache, TokenRequest } from 'pintra-fx';
import Axios from 'axios';

export class SharePointHome {
  public static async get(env: IEnv) {
    const tokenResponse: IToken | TokenRequestError = await TokenCache.getToken(
      new TokenRequest('graph', 'https://graph.microsoft.com'),
      {
        wpAjaxAdminUrl: env.wpAjaxAdminUrl,
        nonce: env.nonce
      }
    );

    if (tokenResponse instanceof Error) {
      return new Error('Unexpected: Could not retrieve a valid access token.');
    }

    const token = <IToken>tokenResponse;

    const response = await Axios.get(
      'https://graph.microsoft.com/v1.0/sites/root',
      {
        headers: {
          Authorization: `Bearer ${token.bearer}`,
          Accept: 'application/json'
        }
      }
    );

    return response;
  }
}
